const eventPinConfigs = {
    Fun: { background: '#FF6B6B', borderColor: '#E55555', glyphColor: 'white', glyph: '🎉' },
    '5 words: Live Music': { background: '#4ECDC4', borderColor: '#45B7B8', glyphColor: 'white', glyph: '🎵' },
    'Live Music': { background: '#4ECDC4', borderColor: '#45B7B8', glyphColor: 'white', glyph: '🎵' },
    'Music Concert': { background: '#4ECDC4', borderColor: '#45B7B8', glyphColor: 'white', glyph: '🎤' },
    Concert: { background: '#4ECDC4', borderColor: '#45B7B8', glyphColor: 'white', glyph: '🎤' },
    'Available tickets': { background: '#FFD93D', borderColor: '#F6C23E', glyphColor: 'black', glyph: '🎟️' },
    Tickets: { background: '#FFD93D', borderColor: '#F6C23E', glyphColor: 'black', glyph: '🎟️' },
    Baseball: { background: '#28A745', borderColor: '#1E7E34', glyphColor: 'white', glyph: '⚾' },
    Basketball: { background: '#FD7E14', borderColor: '#E8590C', glyphColor: 'white', glyph: '🏀' },
    Sports: { background: '#6F42C1', borderColor: '#5A2A94', glyphColor: 'white', glyph: '🏈' },
    Beer: { background: '#FFC107', borderColor: '#E0A800', glyphColor: 'black', glyph: '🍺' },
    Oktoberfest: { background: '#FFC107', borderColor: '#E0A800', glyphColor: 'black', glyph: '🍻' },
    'Wine tasting': { background: '#6F2C91', borderColor: '#5A2472', glyphColor: 'white', glyph: '🍷' },
    'Whiskey Tasting': { background: '#8B4513', borderColor: '#7A3D11', glyphColor: 'white', glyph: '🥃' },
    Tasting: { background: '#6F2C91', borderColor: '#5A2472', glyphColor: 'white', glyph: '🍷' },
    'Bike ride': { background: '#20C997', borderColor: '#1BA085', glyphColor: 'white', glyph: '🚴' },
    Hike: { background: '#795548', borderColor: '#6D4C41', glyphColor: 'white', glyph: '🥾' },
    Dance: { background: '#E91E63', borderColor: '#C2185B', glyphColor: 'white', glyph: '💃' },
    'Latin dance': { background: '#E91E63', borderColor: '#C2185B', glyphColor: 'white', glyph: '💃' },
    'Comedy show': { background: '#FFEB3B', borderColor: '#FBC02D', glyphColor: 'black', glyph: '🤣' },
    'Food truck festival': { background: '#FF5722', borderColor: '#E64A19', glyphColor: 'white', glyph: '🚚' },
    Brunch: { background: '#FF9800', borderColor: '#F57C00', glyphColor: 'white', glyph: '🍳' },
    cooking: { background: '#FF9800', borderColor: '#F57C00', glyphColor: 'white', glyph: '🍳' },
    Christmas: { background: '#4CAF50', borderColor: '#388E3C', glyphColor: 'white', glyph: '🎄' },
    Halloween: { background: '#FF5722', borderColor: '#D84315', glyphColor: 'white', glyph: '🎃' },
    "Valentine's Day": { background: '#E91E63', borderColor: '#AD1457', glyphColor: 'white', glyph: '❤️' },
    "New Year's Eve": { background: '#FFD700', borderColor: '#FFC107', glyphColor: 'black', glyph: '🎉' },
    'St Patrick Celebration': { background: '#4CAF50', borderColor: '#2E7D32', glyphColor: 'white', glyph: '🍀' },
    Film: { background: '#9C27B0', borderColor: '#7B1FA2', glyphColor: 'white', glyph: '🎥' },
    Show: { background: '#9C27B0', borderColor: '#7B1FA2', glyphColor: 'white', glyph: '🎭' },
    Exhibition: { background: '#607D8B', borderColor: '#455A64', glyphColor: 'white', glyph: '🖼️' },
    Book: { background: '#795548', borderColor: '#5D4037', glyphColor: 'white', glyph: '📚' },
    'Library Event': { background: '#795548', borderColor: '#5D4037', glyphColor: 'white', glyph: '📚' },
    Storytime: { background: '#795548', borderColor: '#5D4037', glyphColor: 'white', glyph: '📖' },
    Games: { background: '#3F51B5', borderColor: '#303F9F', glyphColor: 'white', glyph: '🎲' },
    'Table Games': { background: '#3F51B5', borderColor: '#303F9F', glyphColor: 'white', glyph: '🎲' },
    'Trivia Night': { background: '#FF9800', borderColor: '#F57C00', glyphColor: 'white', glyph: '🧠' },
    Painting: { background: '#E91E63', borderColor: '#C2185B', glyphColor: 'white', glyph: '🎨' },
    Drawing: { background: '#E91E63', borderColor: '#C2185B', glyphColor: 'white', glyph: '🎨' },
    Pottery: { background: '#8D6E63', borderColor: '#6D4C41', glyphColor: 'white', glyph: '🏺' },
    Tour: { background: '#607D8B', borderColor: '#455A64', glyphColor: 'white', glyph: '🚶' },
    Meeting: { background: '#2196F3', borderColor: '#1976D2', glyphColor: 'white', glyph: '🤝' },
    Social: { background: '#FF9800', borderColor: '#F57C00', glyphColor: 'white', glyph: '👥' },
    'Social event': { background: '#FF9800', borderColor: '#F57C00', glyphColor: 'white', glyph: '👥' },
    History: { background: '#795548', borderColor: '#5D4037', glyphColor: 'white', glyph: '🏛️' },
    Meet: { background: '#14B8A6', borderColor: '#0F766E', glyphColor: 'white', glyph: '🤝' },
}

function normalizeCategoryKey(value) {
    return typeof value === 'string' ? value.trim().toLowerCase() : ''
}

const normalizedEventPinConfigs = Object.fromEntries(
    Object.entries(eventPinConfigs).map(([key, config]) => [normalizeCategoryKey(key), config]),
)

const restaurantStyle = { background: '#FF6347', borderColor: '#DC143C', glyphColor: 'white', glyph: '🍽️' }
const fastFoodStyle = { background: '#FFD700', borderColor: '#FFA500', glyphColor: 'black', glyph: '🍔' }
const pizzaStyle = { background: '#FF4500', borderColor: '#CC3300', glyphColor: 'white', glyph: '🍕' }
const coffeeShopStyle = { background: '#8B4513', borderColor: '#654321', glyphColor: 'white', glyph: '☕' }
const barStyle = { background: '#4B0082', borderColor: '#2E0052', glyphColor: 'white', glyph: '🍺' }
const pubStyle = { background: '#4B0082', borderColor: '#2E0052', glyphColor: 'white', glyph: '🍻' }
const bakeryStyle = { background: '#DEB887', borderColor: '#CD853F', glyphColor: 'black', glyph: '🥖' }
const iceCreamStyle = { background: '#FFB6C1', borderColor: '#FF69B4', glyphColor: 'black', glyph: '🍦' }
const groceryStoreStyle = { background: '#32CD32', borderColor: '#228B22', glyphColor: 'white', glyph: '🛒' }
const gasStationStyle = { background: '#FF1493', borderColor: '#DC143C', glyphColor: 'white', glyph: '⛽' }
const hotelStyle = { background: '#4682B4', borderColor: '#2F4F4F', glyphColor: 'white', glyph: '🏨' }
const bankStyle = { background: '#2F4F4F', borderColor: '#191970', glyphColor: 'white', glyph: '🏦' }
const atmStyle = { background: '#2F4F4F', borderColor: '#191970', glyphColor: 'white', glyph: '💳' }
const hospitalStyle = { background: '#DC143C', borderColor: '#8B0000', glyphColor: 'white', glyph: '🏥' }
const pharmacyStyle = { background: '#32CD32', borderColor: '#228B22', glyphColor: 'white', glyph: '💊' }
const mallStyle = { background: '#FF69B4', borderColor: '#C71585', glyphColor: 'white', glyph: '🛍️' }
const storeStyle = { background: '#FF69B4', borderColor: '#C71585', glyphColor: 'white', glyph: '🏪' }
const gymStyle = { background: '#FF4500', borderColor: '#CC3300', glyphColor: 'white', glyph: '💪' }
const schoolStyle = { background: '#FFD700', borderColor: '#FFA500', glyphColor: 'black', glyph: '🏫' }
const playSpacesStyle = { background: '#34D399', borderColor: '#059669', glyphColor: 'white', glyph: '🛝' }
const museumStyle = { background: '#60A5FA', borderColor: '#2563EB', glyphColor: 'white', glyph: '🏛️' }
const breweryStyle = { background: '#F59E0B', borderColor: '#B45309', glyphColor: 'white', glyph: '🍺' }

// Highlighted place categories flagged with importance in place_categories.csv
const placePinConfigs = {
    restaurant: restaurantStyle,
    foodestablishment: restaurantStyle,
    'fast food': fastFoodStyle,
    fastfoodrestaurant: fastFoodStyle,
    pizza: pizzaStyle,
    'coffee shop': coffeeShopStyle,
    cafe: coffeeShopStyle,
    cafeorcoffeeshop: coffeeShopStyle,
    bar: barStyle,
    pub: pubStyle,
    barorpub: pubStyle,
    adultentertainment: { background: '#6F42C1', borderColor: '#5A2A94', glyphColor: 'white', glyph: '🌙' },
    amusementpark: { background: '#FF6B6B', borderColor: '#E55555', glyphColor: 'white', glyph: '🎢' },
    aquarium: { background: '#0EA5E9', borderColor: '#0369A1', glyphColor: 'white', glyph: '🐠' },
    artgallery: { background: '#9C27B0', borderColor: '#7B1FA2', glyphColor: 'white', glyph: '🖼️' },
    bakery: bakeryStyle,
    desserts: { background: '#F472B6', borderColor: '#BE185D', glyphColor: 'white', glyph: '🍰' },
    'ice cream': iceCreamStyle,
    icecreamshop: iceCreamStyle,
    'grocery store': groceryStoreStyle,
    grocerystore: groceryStoreStyle,
    supermarket: groceryStoreStyle,
    brewery: breweryStyle,
    breweries: breweryStyle,
    barandgrill: barStyle,
    bookstore: { background: '#8B5E3C', borderColor: '#6F4E27', glyphColor: 'white', glyph: '📚' },
    bowlingalley: { background: '#F97316', borderColor: '#C2410C', glyphColor: 'white', glyph: '🎳' },
    casino: { background: '#1D4ED8', borderColor: '#1E3A8A', glyphColor: 'white', glyph: '🎰' },
    comedyclub: { background: '#FACC15', borderColor: '#D97706', glyphColor: 'black', glyph: '🤣' },
    dayspa: { background: '#22D3EE', borderColor: '#0E7490', glyphColor: 'black', glyph: '💆' },
    distillery: { background: '#A16207', borderColor: '#854D0E', glyphColor: 'white', glyph: '🥃' },
    entertainmentbusiness: { background: '#9333EA', borderColor: '#7E22CE', glyphColor: 'white', glyph: '🎭' },
    eventvenue: { background: '#DB2777', borderColor: '#BE185D', glyphColor: 'white', glyph: '🎟️' },
    florist: { background: '#22C55E', borderColor: '#15803D', glyphColor: 'white', glyph: '🌸' },
    golfcourse: { background: '#16A34A', borderColor: '#166534', glyphColor: 'white', glyph: '🏌️' },
    healthandbeautybusiness: { background: '#EC4899', borderColor: '#BE123C', glyphColor: 'white', glyph: '💄' },
    healthclub: gymStyle,
    hobbyshop: { background: '#0EA5E9', borderColor: '#0284C7', glyphColor: 'white', glyph: '🧩' },
    liquorstore: { background: '#7C3AED', borderColor: '#5B21B6', glyphColor: 'white', glyph: '🍾' },
    meetingroom: { background: '#3B82F6', borderColor: '#1D4ED8', glyphColor: 'white', glyph: '🏢' },
    movietheater: { background: '#F97316', borderColor: '#9A3412', glyphColor: 'white', glyph: '🎬' },
    museum: museumStyle,
    museums: museumStyle,
    musicstore: { background: '#C084FC', borderColor: '#A855F7', glyphColor: 'white', glyph: '🎸' },
    musicvenue: { background: '#10B981', borderColor: '#047857', glyphColor: 'white', glyph: '🎶' },
    nightclub: { background: '#0F172A', borderColor: '#1E3A8A', glyphColor: 'white', glyph: '🕺' },
    park: { background: '#22C55E', borderColor: '#15803D', glyphColor: 'white', glyph: '🌳' },
    playground: playSpacesStyle,
    'play spaces': playSpacesStyle,
    parkingfacility: { background: '#6B7280', borderColor: '#4B5563', glyphColor: 'white', glyph: '🅿️' },
    pawnshop: { background: '#F59E0B', borderColor: '#B45309', glyphColor: 'white', glyph: '💰' },
    performingartstheater: { background: '#A855F7', borderColor: '#7C3AED', glyphColor: 'white', glyph: '🎭' },
    resort: { background: '#38BDF8', borderColor: '#0EA5E9', glyphColor: 'white', glyph: '🏖️' },
    skiresort: { background: '#38BDF8', borderColor: '#0369A1', glyphColor: 'white', glyph: '🎿' },
    sportsactivitylocation: { background: '#22D3EE', borderColor: '#0891B2', glyphColor: 'white', glyph: '🏅' },
    sportsclub: { background: '#FB7185', borderColor: '#E11D48', glyphColor: 'white', glyph: '🏈' },
    stadiumorarena: { background: '#F97316', borderColor: '#9A3412', glyphColor: 'white', glyph: '🏟️' },
    touristattraction: { background: '#FCD34D', borderColor: '#F59E0B', glyphColor: 'black', glyph: '📸' },
    touristdestination: { background: '#F97316', borderColor: '#C2410C', glyphColor: 'white', glyph: '🧭' },
    touristinformationcenter: { background: '#60A5FA', borderColor: '#2563EB', glyphColor: 'white', glyph: 'ℹ️' },
    winery: { background: '#7C2D12', borderColor: '#5B1A0A', glyphColor: 'white', glyph: '🍷' },
    zoo: { background: '#F97316', borderColor: '#B45309', glyphColor: 'white', glyph: '🦁' },
    bakerycafe: bakeryStyle,
    'gas station': gasStationStyle,
    gasstation: gasStationStyle,
    hotel: hotelStyle,
    bank: bankStyle,
    atm: atmStyle,
    hospital: hospitalStyle,
    pharmacy: pharmacyStyle,
    'shopping mall': mallStyle,
    store: storeStyle,
    gym: gymStyle,
    'fitness center': gymStyle,
    school: schoolStyle,
    brewerypub: breweryStyle,
    'coffee house': coffeeShopStyle,
    coffeehouse: coffeeShopStyle,
}

export function getEventPinConfig(eventCategory) {
    return normalizedEventPinConfigs[normalizeCategoryKey(eventCategory)] || {
        background: '#FBBC04',
        borderColor: '#137333',
        glyphColor: 'white',
        glyph: '📍',
    }
}

export function getPlacePinConfig(placeCategory) {
    return placePinConfigs[normalizeCategoryKey(placeCategory)] || {
        background: '#2563EB',
        borderColor: '#1D4ED8',
        glyphColor: 'white',
        glyph: '📍',
    }
}
